module.exports = __webpack_public_path__ + "assets/images/upgrade-graphic-basic@3x-8ad8539b0bd6172eb3f06934531ba020.jpg";